import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  user = null;

  constructor(user) {
    this.user = user;
  }

  @computed get isPage1Valid() {
    const data = this.offerData;

    return (
      !!data.property_name &&
      !!data.estate &&
      !!data.quarter &&
      !!data.island &&
      !!data.deed_type &&
      !!data.tenancy_current
    );
  }

  @computed get isPage2Valid() {
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      // Page1
      property_name: offerData.property_name || '',
      address: offerData.address || '',
      estate: offerData.estate || '',
      quarter: offerData.quarter || '',
      island: offerData.island || '',
      map_reference: offerData.map_reference || '',
      tax_parcel_number: offerData.tax_parcel_number || '',
      additional_description: offerData.additional_description || '',
      deed_type: offerData.deed_type || '',
      tenancy_current: offerData.tenancy_current || '',
      lead_warning_disclosure: offerData.lead_warning_disclosure || false,

      // Page2
      seller_type: offerData.seller_type || 'private',
      seller_company_name: offerData.seller_company_name || '',
      seller_vat_id: offerData.seller_company_vat_id || '',
      seller_firstName: offerData.seller_firstName || '',
      seller_lastName: offerData.seller_lastName || '',
      seller_dob: offerData.seller_dob || '',
      seller_pob: offerData.seller_pob || '',
      seller_street: offerData.seller_street || '',
      seller_house_number: offerData.seller_house_number || '',
      seller_street_additional: offerData.seller_street_additional || '',
      seller_city: offerData.seller_city || '',
      seller_state: offerData.seller_state || '',
      seller_zip: offerData.seller_zip || '',
      seller_country: offerData.seller_country || 'U.S. Virgin Islands',
      seller_country_code: offerData.seller_country_code || 'VI',
      additional_sellers: offerData.additional_sellers || [],
      proposal_stamp_tax: offerData.proposal_stamp_tax || '',
      agent_representing: offerData.agent_representing || false,
      seller_exchange: offerData.seller_exchange || false,
      closing_location: offerData.closing_location || '',
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_vi/stores/index.js